import {ReactNode, Suspense} from 'react';

const withSuspense = <T extends object>(Component: (props: T) => JSX.Element, fallbackRender: () => ReactNode) => {
  // eslint-disable-next-line react/display-name
  return (props: T) => (
    <Suspense fallback={fallbackRender()}>
      <Component {...props} />
    </Suspense>
  );
};

export default withSuspense;
